import React, { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Typography, CircularProgress } from "@mui/material"
import { useAuthUser } from "react-auth-kit"
import api from "../../utils/api"

const styles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50vh",
    flexDirection: "column",
  } as React.CSSProperties,
}

function LobbyPage() {
  const { id } = useParams<{ id: string }>()
  const auth = useAuthUser()
  const navigate = useNavigate()
  const eventId = auth()?.eventId

  // all instance ids from eventId
  useEffect(() => {
    if (eventId) {
      api
        .get(`/admin/events/${eventId}/voting-instances-ids`)
        .then((response) => {
          const instances = response.data
          const exists = instances.some((instance: any) => instance.id === id)
          if (!exists) {
            navigate(
              "/not-authorized?message=The%20voting%20instance%20you%20are%20trying%20to%20access%20does%20not%20exist."
            )
          }
        })
        .catch((error) => {
          console.error("Error fetching voting instances:", error)
        })

      api
        .get(`/admin/instances/${id}/status`)
        .then((response) => {
          const status = response.data.status
          if (status === "pre-voting") {
            navigate(`/voter/instance/${id}/questions`)
          } else {
            navigate(
              "/not-authorized?message=The%20voting%20instance%20you%20are%20trying%20to%20access%20is%20not%20open%20for%20voting."
            )
          }
        })
        .catch((error) => {
          console.error("Error fetching voting instances:", error)
        })
    }
  }, [eventId, id, navigate])

  return (
    <div style={styles.mainContainer}>
      <Typography variant="h5" gutterBottom sx={{ marginBottom: 4 }}>
        Waiting for Instance to Open... Refresh the page if it doesn't load.
      </Typography>
      <CircularProgress />
    </div>
  )
}

export default LobbyPage
